import { render } from "./PRPMicroneedlingFacialContent.vue?vue&type=template&id=24086e18&scoped=true"
import script from "./PRPMicroneedlingFacialContent.vue?vue&type=script&lang=js"
export * from "./PRPMicroneedlingFacialContent.vue?vue&type=script&lang=js"

import "./PRPMicroneedlingFacialContent.vue?vue&type=style&index=0&id=24086e18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24086e18"]])

export default __exports__